// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sGgSY","question":"styles_question__13l3t","inputVisibleButton":"styles_inputVisibleButton__18Wzi","note":"styles_note__1pjVZ"};